import _extends from "@babel/runtime/helpers/esm/extends";
import { useMemo, useReducer, useRef } from 'react';

function createActionsReducer(actions) {
  return function actionsReducer(state, action) {
    var reducerAction = actions[action.type];
    var reducerActionResult = reducerAction(state, action.payload, action.dispatch, action.type);
    return reducerActionResult;
  };
}

function createActionsDispatchers(actions, dispatchRef) {
  function actionDispatch(payload) {
    return dispatchRef.current(_extends({
      dispatch: dispatchRef.current
    }, payload));
  }

  return Object.keys(actions).reduce(function (accumulator, type) {
    var _extends2;

    return _extends({}, accumulator, (_extends2 = {}, _extends2[type] = function (payload) {
      return dispatchRef.current({
        dispatch: actionDispatch,
        payload: payload,
        type: type
      });
    }, _extends2));
  }, {});
}

export default function useActionsReducer(actions, initialArg, initializer) {
  var reducer = useMemo(function () {
    return createActionsReducer(actions);
  }, [actions]);

  var _useReducer = useReducer(reducer, initialArg, initializer),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var dispatchRef = useRef(dispatch);
  var dispatchers = useMemo(function () {
    return createActionsDispatchers(actions, dispatchRef);
  }, [actions, dispatchRef]);
  var stateWithDispatchers = useMemo(function () {
    return _extends({}, dispatchers, {}, state);
  }, [dispatchers, state]);
  return [stateWithDispatchers, dispatch];
}